import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M5.25 12H6.75M8.25 12H9.75M11.25 12H12.75M14.25 12H15.75M17.25 12H18.75" />
	</SVG>
);
